import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { media } from 'src/components/base';

interface Props {
  richText: boolean;
}
export const ShowAllLink = styled(Link)<Props>`
  ${p =>
    p.richText &&
    css`
      margin-bottom: 20px;
      ${media.mediumUp`
        margin-bottom: 30px;
      `}
    `}

  padding: 10px;
  display: flex;
  align-items: center;
  min-height: 40px;
  justify-content: space-between;
  background-color: ${p => p.theme.colors.base100};
  border-radius: 5px;
`;
